<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} Plisio Configuration</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label v-if="field.name !== 'plisioConfigurationId' || editMode" :for="field.name">{{ field.label }}:</label>

              <input v-if="(field.name !== 'active' && field.name !== 'status' && field.name !== 'plisioConfigurationId' && field.name !== 'application') || (field.name === 'plisioConfigurationId' && editMode)"
                     :id="field.name"
                     v-model="editedConfig[field.name]"
                     :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                     type="text"
                     class="form-control responsive-input"
                     :disabled="(field.name === 'plisioName' || field.name === 'plisioConfigurationId') && editMode">

              <select v-else-if="field.name === 'application'" :id="field.name" v-model="editedConfig[field.name]" class="form-select" style="max-width: 500px;">
                <option v-for="app in applicationList" :key="app" :value="app">{{ app }}</option>
              </select>

              <input class="checkbox" v-else-if="field.name === 'active' || field.name === 'status'"
                     type="checkbox"
                     :id="field.name"
                     v-model="editedConfig[field.name]" >
            </div>

            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">{{ editMode ? 'Save Changes' : 'Create Plisio Configuration' }}</a>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {PlisioConfig} from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'Plisio Edit',
  components: {
    Header,
  },
  data () {
    return {
      editedConfig: {
        plisioConfigurationId: this.$route.params.id,
        plisioName: this.$route.params.plisioName,
        apiKey: this.$route.params.apiKey,
        redirectUrl: this.$route.params.redirectUrl,
        callbackUrl: this.$route.params.callbackUrl,
        failInvoiceUrl: this.$route.params.failInvoiceUrl,
        application : this.$route.params.application,
        active: (this.$route.params.active === 'true'),
        status: (this.$route.params.status === 'true')
      },
      editMode: false,
      applicationList: [],
      fields: [
        { name: "plisioConfigurationId", label: "Plisio Configuration Id" },
        { name: "plisioName", label: "Plisio Name" },
        { name: "apiKey", label: "API Key" },
        { name: "redirectUrl", label: "Redirect URL" },
        { name: "callbackUrl", label: "Callback URL" },
        { name: "failInvoiceUrl", label: "Fail Invoice URL" },
        { name: "application", label: "Application" },
        { name: "active", label: "Active" },
        { name: "status", label: "Status" }
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.id) {
      this.editMode = true;
    }
    const storedApps = localStorage.getItem('applicationList');
    if (storedApps) {
      this.applicationList = JSON.parse(storedApps);
    } else {
      AdminService.getApplications().then(() => {
        this.applicationList = JSON.parse(localStorage.getItem('applicationList'));
      });
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new PlisioConfig(
          this.editedConfig.plisioConfigurationId,
          this.editedConfig.plisioName,
          this.editedConfig.apiKey,
          this.editedConfig.redirectUrl,
          this.editedConfig.callbackUrl,
          this.editedConfig.failInvoiceUrl,
          this.editedConfig.application,
          this.editedConfig.active,
          this.editedConfig.status
      );

      if (this.editMode) {
        AdminService.updatePlisioConfiguration(dataToSave).then(() => {
          alert('Insert complete');
          this.$router.push({ name: 'PlisioConfig' });
        }).catch((error) => {
          console.error("Error updating Plisio configuration:", error);
          if (error.response && error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          }
        });
      } else {
        AdminService.insertPlisioConfiguration(dataToSave).then(() => {
          alert('Insert complete');
          this.$router.push({ name: 'PlisioConfig' });
        }).catch((error) => {
          this.error = error.message
        });
      }
    }
  }
})
</script>

<style src="../../assets/style.css">
</style>
